import { render, staticRenderFns } from "./ybsbgApplyForm.vue?vue&type=template&id=248f96c0&scoped=true&"
import script from "./ybsbgApplyForm.vue?vue&type=script&lang=js&"
export * from "./ybsbgApplyForm.vue?vue&type=script&lang=js&"
import style0 from "./ybsbgApplyForm.vue?vue&type=style&index=0&id=248f96c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248f96c0",
  null
  
)

export default component.exports